import cx from 'classnames';

type OwnProps = {
  isVisible: boolean;
};

export default function NotFoundSearchBarOverlay({ isVisible }: OwnProps) {
  return (
    <div
      aria-hidden="true"
      data-testid="not-found-search-bar-overlay"
      className={cx(
        'pointer-events-none fixed left-0 top-0 z-20 h-dvh w-full bg-canvas-overlay transition-all duration-300',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}
